import * as React from 'react';
import {View} from 'react-native';
import AVText from '../../../AVText';
import Localized from 'src/constants/AppStrings';
export default function UnknownKeypad() {
  return (
    <View>
      <AVText>{Localized.Labels.required_keypad_not_recognized}</AVText>
    </View>
  );
}
